<template>
  <div class="ml-2">
    <img :src="getImage" alt="" style="max-width: 100%"/>
  </div>
</template>

<script>
export default {
  name: 'LayerLegend',

  props: {
    layer: {
      type: Object,
      default() {
        return {};
      }
    }
  },

  computed: {
    getImage() {
      if (this.layer.geoserver_host_id && this.layer.geoserver_host_id !== 'xmap-default') {
        return `${this.layer.ows_host}/${this.layer.owner}_public/wms?request=GetLegendGraphic&width=30&height=30&LAYER=${this.layer.layerid}&FORMAT=image/png&LEGEND_OPTIONS=fontAntiAliasing:true`
      } else {
        return `/legend/${this.layer.owner}:${this.layer.layerid}?width=30&height=30&sid=${Math.random()}`;
      }
    }
  },

  data() {
    return {};
  }
};
</script>

<style scoped>

</style>
